type Callback<T> = (payload: T) => void;

interface DispatchableEvent {
  name: string;
}

export default class EventDispatcher<T extends DispatchableEvent> {
  public listeners: { [index: string]: Callback<T>[] } = {};

  protected addListener(name: string, callback: Callback<T>) {
    if (!(name in this.listeners)) {
      this.listeners[name] = [];
    }

    this.listeners[name].push(callback);
  }

  protected dispatch(event: T) {
    if (!(event.name in this.listeners)) {
      return true;
    }

    const stack = this.listeners[event.name];

    for (let i = 0, l = stack.length; i < l; i++) {
      const callback = stack[i];
      if (typeof callback === 'function') {
        callback.call(this, event);
      }
    }
    return false;
  }
}

export { EventDispatcher, DispatchableEvent };
